import { computed, Directive, Host, HostListener } from '@angular/core';
import { NodeViewComponent } from '@examdojo/core/tiptap';

@Directive({
  selector: '[dojoDragWithHandleOnly]',
  standalone: true,
  host: {
    '[attr.draggable]': 'isDraggable()',
  },
})
export class DragWithHandleOnlyDirective {
  constructor(@Host() private readonly nodeViewComponent: NodeViewComponent<object>) {}

  readonly isDraggable = computed(() => (this.nodeViewComponent.editor().isEditable ? 'true' : 'false'));

  /**
   * Ensures a node is only draggable with its handle only, not the node itself
   * @param event
   */
  @HostListener('dragstart', ['$event'])
  handleDragStart(event: DragEvent): void {
    const target = event.target as Element | null;
    if (target?.closest?.('[data-drag-handle]')) {
      return;
    }
    event.preventDefault();
    event.stopPropagation();
  }
}
